<template>
  <div
      class="hover-item"
      style="cursor: pointer" @click="$emit('selectRecording', rec.recording)"
      :style="{
              background: selectedRec === rec.recording ? 'var(--selected-item)' : null
            }"
  >
    <v-layout row style="overflow-x: hidden" class="px-2 py-1" align-center>

      <v-flex shrink class="pr-2">
        <simple-audio
            :src="previewAddress"
        />
      </v-flex>
      <v-flex xs5 style="overflow-x: hidden" class="py-1">
        <div class="body-1 text-truncate" style="overflow-x: hidden">
          {{ callFromDisplay }}
        </div>
      </v-flex>
      <v-flex xs5 style="overflow-x: hidden" class="py-1">
        <div class="body-1 text-truncate" style="overflow-x: hidden">
          {{ callToDisplay }}
        </div>
      </v-flex>

      <v-flex xs2 class="caption font-weight-bold greyType--text " style="white-space: nowrap">
        {{ recordingDuration }}
      </v-flex>

      <v-flex xs2 class="caption font-weight-bold greyType--text mr-3" style="white-space: nowrap">
        {{ recordingDate }} {{ recordingTime }}
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
  </div>
</template>

<script>
import {codeBaseMixin} from "../../../../codeBaseMixin";
import SimpleAudio from "../../../../components/General/SimpleAudio";
import {mapGetters} from "vuex";
import {serverAddress} from "@/axiosRequest";
import {token} from "@/tokenManSite";

export default {
  mixins: [codeBaseMixin],
  components: {
    SimpleAudio,
  },
  props: {
    rec: Object,
    selectedRec: String,
    showFrom: {default: true, type: Boolean},
    showTo: {default: true, type: Boolean}
  },
  methods: {
    formatNumber(num) {
      if (num == null) return '';
      const raw = String(num).trim();
      if (!raw) return '';
      const digits = raw.replace(/\D/g, '');
      if (!digits) return raw;
      if (digits.length >= 1 && digits.length <= 5) return `ext ${digits}`;
      if (digits.length === 13 && digits.startsWith('0027')) {
        const nat = digits.slice(4);
        return `+27 ${nat.slice(0, 2)} ${nat.slice(2, 5)} ${nat.slice(5)}`;
      }
      if (digits.length === 11 && digits.startsWith('27')) {
        const nat = digits.slice(2);
        return `+27 ${nat.slice(0, 2)} ${nat.slice(2, 5)} ${nat.slice(5)}`;
      }
      if (digits.length === 10 && digits.startsWith('0')) {
        return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
      }
      // E.164 with leading +
      if (raw.startsWith('+27') && digits.length === 11) {
        const nat = digits.slice(2);
        return `+27 ${nat.slice(0, 2)} ${nat.slice(2, 5)} ${nat.slice(5)}`;
      }
      return raw;
    },
  },
  computed: {
    ...mapGetters("userInfo", ["userInfo"]),

    callFromDisplay() {
      return this.formatNumber(this.rec.callfrom);
    },
    callToDisplay() {
      return this.formatNumber(this.rec.callto);
    },

    previewAddress() {
      return `${serverAddress}/othos/recording/preview/${encodeURIComponent(this.rec.recording)}/${token()}`
    },

    recordingDuration() {
      let callTime = +this.rec.callduration

      const minutes = Math.floor(callTime / 60)
      const seconds = callTime % 60

      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },

    recordingTime() {
      return this.getSqlTime(this.rec.timestart)
    },
    recordingDate() {
      return this.getShortDateLongYear(this.rec.timestart)
    },
  }
}
</script>

<style scoped>

</style>
